import styled from "styled-components";
import { Colors } from "../../globalStyles";

export const ButtonDefault = styled.button`
    color: white;
    background-color: ${Colors.primary};
    padding: 1rem;
    cursor: pointer;
    text-transform: uppercase;
    /* border-radius: 6px; */
`;
